import React from "react";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { ListingCard } from "@components/Pages";
import { NothingFilteredAlert, PaymentsSummary, PaymentsTable } from "@components/Statistics";
import { url_reverse } from "@components/Utils";

export default function StatisticsPayments({ gameId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:game:statistics:payments", { game_id: gameId }));

    if (!apiData) return;

    const headerTools = apiData.object_list?.length > 0 && (
        <ExportButton
            size="sm"
            prms={{
                "filter-stats_period": apiData.forms_data.filter.data.stats_period,
                "filter-pers_id": apiData.forms_data.filter.data.pers_id,
            }}
        />
    );

    return (
        <ListingCard header={header} headerTools={headerTools} filterComponent={false}>
            <RenderForm prefix="filter" submitButtonText={t("Построить")} submitMethod="get" />
            <PaymentsSummary />
            <NothingFilteredAlert />
            <PaymentsTable forGame={true} />
        </ListingCard>
    );
}
